// @ts-nocheck
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface AttributesProps {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    innerWrapper?: InjectableCss;
    item?: GridItemProps;
    label?: TypographyPresentationProps;
    value?: TypographyPresentationProps;
}

export const attributeSpacing = pxToRem(3);

export const baseStyles = () => css`
    /* Store Removed Code - color */

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smallest};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const attributesProps: AttributesProps = {
    wrapper: {
        css: css`
            display: block;
            ${baseStyles()}
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles([], [attributeSpacing])}
            ${baseStyles()}
        `,
    },
    innerWrapper: {
        css: css`
            display: block;
            ${spacingStyles(null, attributeSpacing)}
        `,
    },
    item: {
        width: 12,
        css: css`
            flex-flow: wrap;
        `,
    },
    label: {
        css: css`
            margin-right: 0.3em;
        `,
    },
    value: {
        css: css`
            word-break: break-all;
        `,
    },
};
